export default "__VITE_PUBLIC_ASSET__83151627__"